<template>
  <section
    class="section section-shaped section-lg my-0"
    style="padding-top:100px;"
  >
    <!-- <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
    </div> -->
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-11">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-center text-muted">
                <h1><b>Waiting Room</b></h1>
                <h3>
                  Please wait and you will join the meeting soon.
                </h3>

                <img src="/img/waiting.gif" height="80" width="80" />
                <!-- <br /> -->
                <!-- <h6>Login ID: {{ username }}</h6>
                <h6>Case ID: {{ case_id }}</h6>
                <h6>Current Status: {{ status }}</h6> -->

                <table style="margin-bottom:20px;">
                  <thead>
                    <td width="200px"></td>
                    <td width="800px"></td>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="text-align: right; vertical-align: middle;">
                        Meeting:
                      </td>
                      <td style="text-align: left; vertical-align: middle;">
                        {{ case_id }} {{ case_description }}
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: right; vertical-align: middle;">
                        Login ID:
                      </td>
                      <td style="text-align: left; vertical-align: middle;">
                        {{ username }}
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: right; vertical-align: middle;">
                        System assigned:
                      </td>
                      <td style="text-align: left; vertical-align: middle;">
                        {{ name }}
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: right; vertical-align: middle;">
                        Your name:
                      </td>
                      <td style="text-align: left; vertical-align: middle;">
                        {{ input_name }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <h6>If you have any questions, please email courtav&itsupportteam@judiciary.hk</h6>
                <br />
                <h6>If you want to quit, please press the QUIT button.</h6>
                <base-button type="primary" @click="quit()">QUIT</base-button>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// @ is an alias to /src

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "WaitingRoom",
  data() {
    return {
      join_seq: 1,
      username: this.$route.params.username,
      case_id: this.$route.params.case_id,
      case_description: this.$route.params.case_description,
      name: this.$route.params.name,
      input_name: this.$route.params.input_name,
      status: "Sending Join Request",
      join_waiting_internal: null,
    };
  },
  created() {
    window.addEventListener("beforeunload", this.close_browser);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.close_browser);
    if (this.join_waiting_internal) {
      clearInterval(this.join_waiting_internal);
    }
  },
  methods: {
    close_browser(e) {
      var confirmationMessage = "\o/";

      (e || window.event).returnValue = confirmationMessage; //Gecko + IE
      return confirmationMessage; //Webkit, Safari, Chrome
    },
    quit() {
      clearInterval(this.join_waiting_internal);

      axios
        .post(process.env.VUE_APP_WEB_HOST + "/meeting/quit", {
          case_id: this.case_id,
        })
        .then((res) => {
          // eslint-disable-next-line
          this.logout();
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    logout() {
      axios
        .get(process.env.VUE_APP_WEB_HOST + "/auth/logout", {})
        .then(() => {
          console.log("logout");
          this.$router.push({
            name: "Home",
            params: {},
          });
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    join() {
      let data_to_server = {
        status: "waiting",
        case_id: this.case_id,
        input_name: this.$route.params.input_name,
        seq: this.join_seq,
      };

      axios
        .post(process.env.VUE_APP_WEB_HOST + "/meeting/join", data_to_server)
        .then((res) => {
          this.join_seq++;

          this.status = res.data.status;

          if (this.status == "join_allowed") {
            clearInterval(this.join_waiting_internal);
            let meeting = res.data;
            meeting.username = this.username;
            meeting.case_id = this.case_id;
            meeting.name = this.$route.params.name;
            meeting.input_name = this.$route.params.input_name;
            this.$router.push({
              name: "Participant",
              params: {
                meeting: meeting,
              },
            });
          } else if (this.status == "join_rejected") {
            clearInterval(this.join_waiting_internal);
            this.$router.push({
              name: "Reject",
            });
          } else if (this.status == "ended") {
            clearInterval(this.join_waiting_internal);

            if (
              res.data.another_session ||
              res.data.another_session_in_the_meeting
            ) {
              console.log("another_session");
              this.$router.push({
                name: "EndMeeting",
                params: {
                  case_id: this.case_id,
                  template: "duplicate_session",
                },
              });
            } else {
              this.$router.push({
                name: "EndMeeting",
                params: {
                  case_id: this.case_id,
                  title:
                    "The meeting of " +
                    this.case_id +
                    " ends.",
                  message: ["You have logged out from the system."],
                },
              });
            }
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
  },
  components: {},
  mounted() {
    // eslint-disable-next-line
    console.log("mounted");
    this.join();
    this.join_waiting_internal = setInterval(this.join, 3000);
  },
};
</script>

<style scoped>
table {
  border-collapse: separate;
  border-spacing: 10px 5px;
}
</style>
